import { useRef, useEffect } from "react";

//Common
import { SHOW_DESC_OBRIGATORIO_FIELDS } from "@/common/constantes";

//Unform e componentes
import { useField } from "@unform/core";

//Tamanho do checkbox (pode ser alterado na tela pela propriedade style)
const ESTILO_CHECK = {
  width: "1.10rem",
  height: "1.10rem",
};

function UCheckbox({
  name,
  label,
  defaultChecked,
  disabled,
  //showIcone = false,
  ...rest
}) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: (ref) => {
        return ref.checked;
      },
      setValue: (ref, value) => {
        ref.checked = value;
      },
      clearValue: (ref) => {
        ref.checked = false;
      },
    });
  }, [fieldName, registerField]);

  return (
    <div className="d-flex">
      {/* d-flex align-items-center: alinha o label com o check na vertical */}
      <div
        className={"d-flex align-items-center ".concat(
          error && SHOW_DESC_OBRIGATORIO_FIELDS == false
            ? "border border-danger rounded p-2"
            : "",
        )}
      >
        <input
          type="checkbox"
          ref={inputRef}
          name={fieldName} //novo
          defaultChecked={defaultChecked || defaultValue}
          disabled={disabled}
          style={ESTILO_CHECK}
          {...rest}
        />
        &nbsp;
        {label && (
          <span
            className={"text-nowrap me-1 ".concat(
              disabled ? "label-disabled" : "label",
            )}
          >
            {label}
          </span>
        )}
      </div>
    </div>
  );
}

export default UCheckbox;
